import { faListUl } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { ParticipantViewModel } from 'stageclip-common';

import { ModalId } from '../../../constants/modalId';
import * as NotificationHelper from '../../../helpers/notificationHelper';
import CopyButton from '../../buttons/copyButton';
import { ComponentBase, BaseDispatchProps, BaseStateProps } from '../../componentBase';
import AppModal from '../../modal/appModal';

import styles from './aegisubNamesModal.module.scss';

export interface AegisubDataModalOwnProps {
  eventId: string;
  warningText?: string;
}

export interface AegisubDataModalStateProps extends BaseStateProps {
  participants: ParticipantViewModel[];
}

export interface AegisubDataModalDispatchProps extends BaseDispatchProps {
  loadEventParticipants: (c: AegisubDataModal) => void;
}

interface AegisubDataModalState {
  title: string;
  text: string;
  getDataToCopy: (participants: ParticipantViewModel[]) => string[];
  warningText?: string;
  filteredParticipants?: ParticipantViewModel[];
}

export abstract class AegisubDataModal<
  StateProps extends AegisubDataModalStateProps = AegisubDataModalStateProps,
  DispatchProps extends AegisubDataModalDispatchProps = AegisubDataModalDispatchProps
> extends ComponentBase<AegisubDataModalOwnProps, StateProps, DispatchProps, AegisubDataModalState> {
  protected constructor(protected id: ModalId, props: any) {
    super(props);
    this.state = {
      getDataToCopy: () => undefined,
      text: undefined,
      title: undefined,
    };
  }

  protected dataLoaded(props: any) {
    return props.participants;
  }

  protected async loadData(props: any) {
    if (!props.participants) {
      await props.loadEventParticipants(this);
    }
  }

  protected loggedInRender() {
    const text = this.getDataToCopy();

    return (
      <AppModal id={this.id} title={this.state.title} buttonIcon={faListUl} invertedButtonColours>
        <div>
          <div className={styles.fieldsBeforeText}>{this.renderFieldsBeforeText()}</div>
          <div>
            <CopyButton text={text} displayValue={this.state.text} onClick={this.copyToClipboardOnClick} />
          </div>
          {this.state.warningText && <span>{this.state.warningText}</span>}
          <textarea disabled value={text} className={styles.textarea} />
        </div>
      </AppModal>
    );
  }

  protected getDataToCopy() {
    return this.state.getDataToCopy(this.state.filteredParticipants || this.props.participants).join('\n');
  }

  // noinspection JSMethodCanBeStatic
  protected renderFieldsBeforeText(): JSX.Element | string {
    return '';
  }

  private copyToClipboardOnClick() {
    NotificationHelper.success('Data copied!');
  }
}
